/*-----------------------------------------------------------------
- Categories translations
-----------------------------------------------------------------*/

export default {
    categories: 'All Category',
};
